<div class = "container m-0 p-0">
    <div class="header mb-2" mat-button mat-dialog-close>
    <h6 class="dialog-title">{{ MessageText | translate}}</h6>
        <div class ="row flex justify-content-center align-items-center">
            <div class = "col-6 m-0 p-1 button-container"> 
                <button class="confirm-button mat-elevation-z4" mat-menu-item (click)="confirm()">{{ ConfirmText | translate }}</button>
            </div>
            <div class = "col-6 m-0 p-1 button-container" *ngIf="ShowCancelButton"> 
                <button class="cancel-button mat-elevation-z4" mat-menu-item (click)="cancel()">{{ CancelText | translate }}</button>
            </div>
        </div>
    </div>
</div>